import React from "react";

const Footer = () => {
    return (
        <footer className="p-4 mt-8 text-center border-t">
            <p className="text-gray">
                © {new Date().getFullYear()} Souhail Khan. All Rights Reserved.
            </p>
        </footer>
    );
};

export default Footer;
